/**
 * Drag bookmarklet links to the bookmarks bar, or use the console script on order.3m.com.
 * Tokens copy to the clipboard — paste into the EIO pipeline page.
 */

/** Extract samlPassThroughToken from cookie line, raw token, or DevTools "Copy as fetch" */
export const extractDeliveryToken = (raw) => {
	if(!raw)	return ''
	let t = String(raw).trim()
	const fromCookie = t.match(/samlPassThroughToken=([^;\s'"]+)/i)
	if(fromCookie)	return fromCookie[1]
	if(/^1:[A-Za-z0-9+/=_-]+$/.test(t))	return t
	const fromFetch = t.match(/samlPassThroughToken['"]?\s*[:=]\s*['"]?(1:[^'";\s]+)/i)
	if(fromFetch)	return fromFetch[1]
	return t
}

const deliveryBookmarkletSource = `(function(){
	function copy(t,msg){
		if(navigator.clipboard&&navigator.clipboard.writeText){
			navigator.clipboard.writeText(t).then(function(){alert(msg);},function(){prompt('Copy token:',t);});
		}else{prompt('Copy token:',t);}
	}
	function fromDocCookie(){
		var m=document.cookie.match(/(?:^|;\\s*)samlPassThroughToken=([^;]*)/);
		return m?decodeURIComponent(m[1]):null;
	}
	function manualHelp(){
		alert('Auto-read failed. Try:\\n\\n1. DevTools → Application → Storage → Cookies → https://order.3m.com → copy samlPassThroughToken\\n\\n2. Network → productAvailability → Copy → Copy as fetch → paste in EIO pipeline → Parse fetch');
	}
	function finish(t){
		if(t){copy(t,'Delivery token copied.\\nPaste in EIO → 3M b.com pipeline → Delivery field.');return;}
		manualHelp();
	}
	var direct=fromDocCookie();
	if(direct){finish(direct);return;}
	if(location.hostname.indexOf('order.3m.com')<0){
		alert('Open order.3m.com while logged in (productAvailability page), then run this again.');
		return;
	}
	var cs=window.cookieStore;
	if(cs&&cs.get){
		cs.get({name:'samlPassThroughToken'}).then(function(c){
			if(c&&c.value){finish(c.value);return;}
			finish(fromDocCookie());
		}).catch(function(){finish(fromDocCookie());});
		return;
	}
	finish(fromDocCookie());
})();`

/** Paste this in DevTools Console on order.3m.com (same logic as bookmarklet) */
export const DELIVERY_CONSOLE_SCRIPT = deliveryBookmarkletSource.replace(/^\(function\(\)\{/, '').replace(/\}\)\(\);$/, '')

const datasetBookmarkletSource = `(function(){
	if(window.__eioBcomSniff){alert('Dataset sniffer already active. Open a product — Bearer copies when the PDP API runs.');return;}
	window.__eioBcomSniff=1;
	function copy(t){
		var msg='Dataset Bearer copied.\\nPaste in EIO → 3M b.com pipeline → Dataset field.';
		if(navigator.clipboard&&navigator.clipboard.writeText){
			navigator.clipboard.writeText(t).then(function(){alert(msg);},function(){prompt('Copy token:',t);});
		}else{prompt('Copy token:',t);}
	}
	function check(url,auth){
		if(!url||!auth)return;
		var a=String(auth);
		if(url.indexOf('searchapi.3m.com')<0&&url.indexOf('/bcom/v1/pdp')<0)return;
		if(a.indexOf('Bearer ')===0)copy(a.slice(7).trim());
		else if(a.indexOf('bearer ')===0)copy(a.slice(7).trim());
	}
	var origFetch=window.fetch;
	if(origFetch){
		window.fetch=function(input,init){
			try{
				var url=typeof input==='string'?input:(input&&input.url)||'';
				var h=init&&init.headers;
				if(h){
					if(typeof h.get==='function')check(url,h.get('Authorization')||h.get('authorization'));
					else check(url,h.Authorization||h.authorization);
				}
			}catch(e){}
			return origFetch.apply(this,arguments);
		};
	}
	var xo=XMLHttpRequest.prototype.open,xs=XMLHttpRequest.prototype.setRequestHeader,xsend=XMLHttpRequest.prototype.send;
	XMLHttpRequest.prototype.setRequestHeader=function(k,v){
		this._eioH=this._eioH||{};
		this._eioH[k]=v;
		return xs.apply(this,arguments);
	};
	XMLHttpRequest.prototype.open=function(m,u){
		this._eioU=u;
		return xo.apply(this,arguments);
	};
	XMLHttpRequest.prototype.send=function(){
		try{
			var h=this._eioH||{};
			check(this._eioU||'',h.Authorization||h.authorization);
		}catch(e){}
		return xsend.apply(this,arguments);
	};
	alert('Dataset sniffer ON.\\nBrowse b.com and open a product — token copies when searchapi PDP runs.');
})();`

const toBookmarkletHref = (source) => `javascript:${encodeURIComponent(source)}`

export const BCOM_BOOKMARKLET_DELIVERY_HREF = toBookmarkletHref(deliveryBookmarkletSource)
export const BCOM_BOOKMARKLET_DATASET_HREF = toBookmarkletHref(datasetBookmarkletSource)
